/**
 * Reload/element — авторитетный снимок таблицы.
 * Без `empty: true` mergeFieldsDefensive не даёт очистить последнюю строку;
 * с залипшим `empty: true` mergePageFieldMaps не даёт добавить первую.
 */

export function tableRowCount(entry: unknown): number {
  if (!entry || typeof entry !== 'object') return 0
  const e = entry as { type?: string; value?: { rows?: unknown[] }; rows?: unknown[] }
  const rows = Array.isArray(e.rows) ? e.rows : Array.isArray(e.value?.rows) ? e.value.rows : null
  return rows ? rows.length : 0
}

export function isUniDataTableEntry(entry: unknown): boolean {
  if (!entry || typeof entry !== 'object') return false
  const type = String((entry as { type?: string }).type ?? '')
  if (type === 'UniDataTable' || type === 'UniDataTableFields') return true
  return tableRowCount(entry) > 0 || (entry as { value?: { empty?: boolean } }).value?.empty === true
}

export function normalizeUniDataTableEmptyFlag<T>(entry: T): T {
  if (!entry || typeof entry !== 'object' || Array.isArray(entry)) return entry
  const typed = entry as { type?: string; value?: unknown }
  const type = String(typed.type ?? '')
  const rawValue = typed.value
  const tableValue =
    rawValue && typeof rawValue === 'object' && !Array.isArray(rawValue)
      ? (rawValue as { rows?: unknown[]; empty?: unknown; columns?: unknown; attributes?: unknown })
      : null
  const rows = Array.isArray(tableValue?.rows)
    ? tableValue.rows
    : Array.isArray((typed as { rows?: unknown[] }).rows)
      ? (typed as { rows: unknown[] }).rows
      : null
  if (rows == null && type !== 'UniDataTable' && type !== 'UniDataTableFields') {
    return entry
  }
  const isEmpty = (rows?.length ?? 0) === 0
  if (tableValue) {
    return {
      ...typed,
      type: type || 'UniDataTable',
      value: {
        ...tableValue,
        rows: rows ?? [],
        empty: isEmpty,
      },
    } as T
  }
  return {
    ...typed,
    type: type || 'UniDataTable',
    value: {
      rows: rows ?? [],
      columns: [],
      attributes: {},
      empty: isEmpty,
    },
  } as T
}

/** Нормализует UniDataTable-поля в карте ответа reload. */
export function normalizeReloadTableFieldsMap(
  fields: Record<string, unknown> | null | undefined,
): Record<string, unknown> {
  if (!fields || typeof fields !== 'object') return {}
  const out: Record<string, unknown> = { ...fields }
  for (const [key, entry] of Object.entries(out)) {
    out[key] = normalizeUniDataTableEmptyFlag(entry)
  }
  return out
}
